export default __webpack_public_path__ + "static/area_7-a8b3df4901eb1d0cb758e09eb5134cd1.jpg";